// prod_mvt_crates operations are namespaced as 'family__subtype'
// ('forklift__receivedDirty', 'special__maintenance'), and for several families the
// bare family name is itself a stored operation. Anything reasoning about a whole
// family therefore has to compare the prefix instead of the operation.

export const SPECIAL = 'special'

// Maintenance and cleaning come around often enough to deserve their own operation
// rather than being told apart by the comment an operator retyped every day.
export const SPECIAL_MAINTENANCE = 'special__maintenance'
export const SPECIAL_CLEANING = 'special__cleaning'

export function operationFamily (operation) {
  return String(operation || '').split('__')[0]
}

export function isSpecialOperation (operation) {
  return operationFamily(operation) === SPECIAL
}
